import React from "react";

const TabFiltersContext = React.createContext({
  section: "",
  maxHeight: 0,
  toggleSection: () => {}
});

export default TabFiltersContext;
